import React from "react";
import styled from "styled-components";
import {Cell} from "./Cell";

export const benchmarkWidth = 80;

const Container = styled(Cell)`
    flex-basis: ${benchmarkWidth + "px"};
    padding-left: 5px;
`;

const Header = styled(Container)`
    font-size: 11px;
    font-weight: bold;
`;

export const Benchmark = ({portfolioIdea}) => {
    const value = portfolioIdea.benchmark ? `${portfolioIdea.benchmark}` : "\u2014";
    return <Container className="t-benchmark">
        {value}
    </Container>
};

export const BenchmarkHeader = () => {
    return <Header>Benchmark</Header>;
};